import { DomainCommonName } from '@foxtail-dev/datacontracts'

export const isLoggedIntoAMarketThatCanImport = (loggedInMarkets: DomainCommonName[]) => {
    return loggedInMarkets.some((domainName) => domainName === 'ebay' || domainName === 'poshmark')
}
